var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRotateIcon = function SvgRotateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.322 5.322 3.365 3.365A15.95 15.95 0 0 1 20 4c8.817 0 16.006 7.195 16 16.012C35.994 28.843 28.833 36 20 36a15.94 15.94 0 0 1-10.721-4.123.776.776 0 0 1-.031-1.125l1.273-1.273a.777.777 0 0 1 1.065-.036A12.6 12.6 0 0 0 20 32.645c6.988 0 12.645-5.655 12.645-12.645 0-6.988-5.655-12.645-12.645-12.645a12.6 12.6 0 0 0-8.943 3.702l3.492 3.492a.774.774 0 0 1-.547 1.322H4.774A.774.774 0 0 1 4 15.097V5.869a.774.774 0 0 1 1.322-.547"
  })));
};
export default SvgRotateIcon;